import AccountCancelConfirmPage from './AccountCancelConfirmPage'

export default AccountCancelConfirmPage
// eslint-disable-next-line import/export
export * from './AccountCancelConfirmPage'
